
export enum BotVal {
  Desire = 'desire',
  BotState = 'bot_status',
  /** 当前追击敌人的高度 */
  EnemyY = "enemy_y",
  /** 当前追击敌人的相对高度 */
  EnemyDiffY = "enemy_diff_y",
  EnemyX = "enemy_x",
  EnemyDiffX = "enemy_diff_x",
  EnemyState = "enemy_state",
  /** 是否处于比较安全的位置 */
  Safe = "safe",
  EnemyOutOfRange = "en_oor",
}
export const BotValDescriptions: Record<BotVal, string> = {
  [BotVal.Desire]: "",
  [BotVal.BotState]: "",
  [BotVal.EnemyY]: "",
  [BotVal.EnemyDiffY]: "",
  [BotVal.EnemyX]: "",
  [BotVal.EnemyDiffX]: "",
  [BotVal.EnemyState]: "",
  [BotVal.Safe]: "",
  [BotVal.EnemyOutOfRange]: "",
}
